const translations = {
  "en": {
    "Failed to load data": "Failed to load data",
    "Others 360° Report": "Others 360° Reports",
    "Please retry after the current response completes": "Please retry after the current response completes"
  },
  "zh-tw": {
    "Failed to load data": "載入資料失敗",
    "Others 360° Report": "其他 360° 報告",
    "Please retry after the current response completes": "請在目前的回應完成後再試一次"
  }
};

export default translations;
